import { http } from '../../../../api/http';
import type { CajaBanco, CajaBancoPermiso, TalonarioChequera } from '../types/cajaBanco';

const ENDPOINT = '/tesoreria/caja-banco';

export class CajaBancoService {
  public static async getAll(): Promise<CajaBanco[]> {
    const response = await http.get(ENDPOINT);
    return response.data;
  }

  public static async getById(id: number): Promise<CajaBanco> {
    const response = await http.get(`${ENDPOINT}/${id}`);
    return response.data;
  }

  public static async save(cajaBanco: CajaBanco): Promise<CajaBanco> {
    if (cajaBanco.idCajaBanco > 0) {
      const response = await http.put(`${ENDPOINT}/${cajaBanco.idCajaBanco}`, cajaBanco);
      return response.data;
    }
    const response = await http.post(ENDPOINT, cajaBanco);
    return response.data;
  }

  public static async delete(id: number): Promise<void> {
    await http.delete(`${ENDPOINT}/${id}`);
  }

  public static async getPermisos(idCajaBanco: number): Promise<CajaBancoPermiso[]> {
    const response = await http.get(`${ENDPOINT}/${idCajaBanco}/permisos`);
    return response.data;
  }

  public static async savePermisos(idCajaBanco: number, permisos: CajaBancoPermiso[]): Promise<void> {
    await http.post(`${ENDPOINT}/${idCajaBanco}/permisos`, permisos);
  }

  public static async getTalonarios(idCajaBanco: number): Promise<TalonarioChequera[]> {
    const response = await http.get(`${ENDPOINT}/${idCajaBanco}/talonarios`);
    return response.data;
  }

  public static async createTalonario(talonario: TalonarioChequera): Promise<TalonarioChequera> {
    const response = await http.post(`${ENDPOINT}/${talonario.idCajaBanco}/talonarios`, talonario);
    return response.data;
  }
}
